import { Injectable, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CurrentUserService } from '@rma/accounts/user';
import { nonNullable } from '@rma/common-ui-rxjs/operators';
import { Environment } from '@rma/generic/util/environment';
import { map } from 'rxjs';
import { TrackJS } from 'trackjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class TrackJsService {
  private readonly userService = inject(CurrentUserService);
  private readonly environment = inject(Environment);

  initialise() {
    if (!TrackJS.isInstalled()) {
      return;
    }

    const { language, version } = this.environment;

    TrackJS.addMetadata('locale', language.locale);

    TrackJS.configure({ version });
    this.userService.currentUser$
      .pipe(
        nonNullable(),
        map(({ userId }) => ({ version, userId })),
        untilDestroyed(this),
      )
      .subscribe((config) => {
        TrackJS.configure(config);
      });
  }
}
